export const config = {
  title: "Villanueva H Construction",
  meta: {
    description:
      "Villanueva H Construction provides high-quality general construction services in Lakewood, CA, and surrounding areas. From home renovations to custom builds, we deliver craftsmanship and integrity in every project.",
    keywords: [
      "Construction Lakewood CA",
      "General Contractor Lakewood",
      "Villanueva Constructions",
      "Home Renovation Lakewood",
      "Custom Home Builder Lakewood CA",
    ],
    author: "Villanueva H Construction",
    canonicalUrl: "https://villanuevahconstructions.com/",
  },
  sections: {
    header: {
      businessName: "Villanueva H Construction",
    },
    sectionB: {
      heroTitle: "Building With Precision, Delivered With Pride",
      heroSubtitle:
        "Reliable Construction Services for Every Home and Business",
      learnAboutText: "Learn More About Us",
      phoneNumber: "7146766491",
      phoneLabel: "(714) 676-6491",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/969348096/photo/engineer-finger-point-on-paper-plan-blueprint-in-check-building-technician-place-construction.jpg?s=612x612&w=0&k=20&c=V1WXYowT_PoN8r56THIkwNgIuvqu-ORY_VndlpZS2Pk=",
      cardData: [
        {
          title: "Residential Construction",
          description:
            "Custom home builds, remodels, and renovations with top-tier craftsmanship.",
        },
        {
          title: "Commercial Projects",
          description:
            "From retail to office spaces, we bring commercial visions to life with precision.",
        },
        {
          title: "Project Management",
          description:
            "End-to-end construction management ensuring your project stays on time and budget.",
        },
      ],
      description:
        "At Villanueva H Construction, we bring years of hands-on experience, attention to detail, and professionalism to every construction project across Lakewood, CA and surrounding areas.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We offer a complete range of construction solutions tailored to meet your residential or commercial needs.",
      cards: [
        {
          title: "New Construction",
          description:
            "From foundation to finish, we build durable and custom structures tailored to your vision.",
          imageSrc:
            "https://media.istockphoto.com/id/2167986788/photo/construction-crew-putting-up-framing-of-new-home.jpg?s=612x612&w=0&k=20&c=PmoyuOSrfFNh7cCUUS8gkmcoQ24jhaOTSrShw_Buobc=",
          imageAlt: "New Construction",
        },
        {
          title: "Painting",
          description:
            "Enhance your property's appearance with professional interior and exterior painting services.",
          imageSrc:
            "https://media.istockphoto.com/id/2148229596/photo/builder-or-painter-in-cap-paints-walls-with-long-painting-roller-business-building-renovation.jpg?s=612x612&w=0&k=20&c=FNNIBhyAajCc0pjguXvk4OdgUnK9MsYdJ-9-dhjQ574=  ",
          imageAlt: "Painting Services",
        },
        {
          title: "Plumbing",
          description:
            "We offer reliable plumbing services including installations, repairs, and maintenance.",
          imageSrc:
            "https://media.istockphoto.com/id/2154150542/photo/plumber-at-work-in-a-bathroom-plumbing-repair-service-fix-water-plumbing-leaks-replace-the.jpg?s=612x612&w=0&k=20&c=d1KnPITNsyfeSZcg54Dd1oge4Lf0VcPf5KvdDS7yu78=",
          imageAlt: "Plumbing Services",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Exterior Remodeling",
        "Interior Remodeling",
        "Framing",
        "Drywall Installation and Repair",
        "Doors and Window Installation",
        "Carpentry",
        "Roofing",
        "Tiling",
        "Flooring",
        "Siding",
        "Concrete",
        "Pool Construction",
        "Patios",
        "Driveway Const",
        "Sidewalk Const",
        "Walkways Const",
        "Electrician",
      ],
    },

    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://media.istockphoto.com/id/1178982949/photo/man-holding-blue-helmet-close-up.jpg?s=612x612&w=0&k=20&c=MyliIMUynBu6lsT8kh_9FvqBKoIUwWGg-iuoNippZPI=",
        alt: "Villanueva H&C Team at Work",
      },
      aboutText: [
        "Villanueva H Construction is a family-owned and operated business proudly serving Lakewood, CA.",
        "We are committed to quality, honesty, and building long-term relationships with our clients through dependable service and unmatched craftsmanship.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Villanueva H Construction Logo",
      businessName: "Villanueva H Construction",
      contact: {
        phone: "7146766491",
        phoneLabel: "(714) 676-6491",
        email: "villanuevahc898@gmail.com",
        website: "https://villanuevahconstructions.com/",
        address: "5866 Adenmoor Ave, Lakewood, CA 90713",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "5866 Adenmoor Ave, Lakewood, CA 90713",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3303.4602635781913!2d-118.1242614!3d33.8587479!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dd31a0e4971f0f%3A0x43dc3c2c8ebc41d3!2s5866%20Adenmoor%20Ave%2C%20Lakewood%2C%20CA%2090713!5e0!3m2!1sen!2sus!4v1717453842374!5m2!1sen!2sus",
    },
  },
};

export default config;
